<template>
  <div>
    <div>
      <div>
        <div>
          <div>
            <div>
              <div class="card-wise-wise">
                <div class="card-header-wise">
                  <h5>Edite Sua Mensagem</h5>
                </div>
                <div>
                  <h4>Campos preenchidos:</h4>

                  <div class="form-group">
                    <label>Título</label>
                    <input
                      :value="selectedMessageToEdit.title"
                      disabled
                      class="form-control"
                    />
                  </div>
                  <div class="form-group">
                    <label>Canal</label>
                    <input
                      :value="selectedMessageToEdit.channel"
                      disabled
                      type="text"
                      class="form-control"
                    />
                  </div>
                  <div class="form-group">
                    <label>Categoria</label>
                    <select class="form-control" disabled>
                      <option value="">
                        {{ selectedMessageToEdit.category }}
                      </option>
                    </select>
                  </div>

                  <div
                    v-if="
                      category && category.name.toLowerCase() !== 'whatsnews'
                    "
                    class="form-group"
                  >
                    <label>Status</label>
                    <select
                      v-model="statusSelected"
                      class="form-control"
                      @change="updateStatus"
                    >
                      <option disabled value="">Selecione uma Opção</option>
                      <option
                        v-for="item in category.status"
                        :key="item.name"
                        :value="item.name"
                      >
                        {{ item.description || item.name }} ({{ item.name }})
                      </option>
                    </select>
                  </div>

                  <div class="shipping-time">
                    <div class="form-group">
                      <label>Situação</label>
                      <select class="form-control" disabled>
                        <option value="">
                          {{ selectedMessageToEdit.situation }}
                        </option>
                      </select>
                    </div>
                    <div class="form-group">
                      <label>Hora de Envio</label>
                      <input
                        v-model="shippingSchedule"
                        type="time"
                        class="form-control-time"
                        @change="updateShippingSchedule"
                      />
                    </div>
                    <div class="form-group">
                      <label>Enviar somente em dias úteis</label>
                      <woot-switch
                        size="large"
                        class="auto-offline--switch"
                        :value="weekendShippingLock"
                        @input="updateWeekendShippingLock"
                      />
                    </div>
                  </div>

                  <div
                    v-if="
                      selectedMessageToEdit.situation === 'Lembrete' &&
                        userData.flexible_notification
                    "
                    class="form-group"
                  >
                    <div
                      v-for="(notification, index) in notifications"
                      :key="index"
                      class="form-input-control"
                    >
                      <label>{{ notification.key }}</label>
                      <input
                        v-model="notification.value"
                        :placeholder="
                          notification.value ||
                            'Quantidade de dias antes da data de vencimento'
                        "
                        type="number"
                        @input="updateNotification(idx)"
                      />
                    </div>
                  </div>
                  <div
                    v-if="
                      selectedMessageToEdit.situation === 'Cobrança' &&
                        userData.flexible_notification
                    "
                    class="form-group"
                  >
                    <div
                      v-for="(notification, index) in notifications"
                      :key="index"
                      class="form-input-control"
                    >
                      <label>{{ notification.key }}</label>
                      <input
                        v-model="notification.value"
                        :placeholder="
                          notification.value ||
                            'Quantidade de dias após da data de vencimento'
                        "
                        type="number"
                        @input="updateNotification(idx)"
                      />
                    </div>
                  </div>
                  <div v-if="userData.flexible_notification">
                    <button
                      :class="notifications.length === 1 ? 'disabled' : ''"
                      :disabled="notifications.length === 1"
                      class="btn btn-danger"
                      @click="removeDinamicNotification(selectedMessageToEdit)"
                    >
                      Excluir
                    </button>
                    <button
                      class="btn btn-info"
                      @click="addDinamicNotification(selectedMessageToEdit)"
                    >
                      Repetir
                    </button>
                  </div>

                  <div
                    v-if="
                      selectedMessageToEdit.situation === 'Lembrete' &&
                        !userData.flexible_notification
                    "
                    class="form-group"
                  >
                    <div class="form-input-control">
                      <label>notificação 1</label>
                      <input
                        v-model="selectedMessageToEdit.notification_1"
                        :placeholder="
                          selectedMessageToEdit.notification_1 ||
                            'Quantidade de dias antes da data de vencimento'
                        "
                        type="number"
                      />
                    </div>
                    <div class="form-input-control">
                      <label>notificação 2</label>
                      <input
                        v-model="selectedMessageToEdit.notification_2"
                        :placeholder="
                          selectedMessageToEdit.notification_2 ||
                            'Quantidade de dias antes da data de vencimento'
                        "
                        type="number"
                      />
                    </div>
                  </div>
                  <div
                    v-if="
                      selectedMessageToEdit.situation === 'Cobrança' &&
                        !userData.flexible_notification
                    "
                    class="form-group"
                  >
                    <div class="form-input-control">
                      <label>notificação 3</label>
                      <input
                        v-model="selectedMessageToEdit.notification_3"
                        :placeholder="
                          selectedMessageToEdit.notification_3 ||
                            'Quantidade de dias antes da data de vencimento'
                        "
                        type="number"
                      />
                    </div>
                    <div class="form-input-control">
                      <label>notificação 4</label>
                      <input
                        v-model="selectedMessageToEdit.notification_4"
                        :placeholder="
                          selectedMessageToEdit.notification_4 ||
                            'Quantidade de dias antes da data de vencimento'
                        "
                        type="number"
                      />
                    </div>
                  </div>

                  <div
                    v-if="
                      category && category.name.toLowerCase() === 'whatsnews'
                    "
                    class="form-group"
                  >
                    <label>ID da Lista</label>
                    <select
                      v-model="selectedList"
                      class="form-control"
                      @change="checkList"
                    >
                      <option
                        v-for="item in lists"
                        :key="item.list_id"
                        :value="item.list_id"
                      >
                        {{ item.nome }} | {{ item.list_id }}
                      </option>
                    </select>
                  </div>

                  <div
                    v-if="
                      category && category.name.toLowerCase() === 'whatsnews'
                    "
                    class="form-group"
                  >
                    <label>Data de Envio</label>
                    <input v-model="date" type="date" class="form-control" />
                    <input
                      v-model="time"
                      type="time"
                      class="form-control"
                      @change="getDate"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    selectedMessageToEdit: {
      type: Object,
      required: true,
      default: () => {},
    },
    userData: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      titleMsgElement: '',
      category: '',
      situation: '',
      situationData: [
        {
          name: 'Lembrete',
          notification: [
            {
              name: 'notificação 1',
              placeholder: 'Dias antes da data de vencimento',
              value: null,
            },
            {
              name: 'notificação 2',
              placeholder: 'Dias antes da data de vencimento',
              value: null,
            },
          ],
        },
        {
          name: 'Cobrança',
          notification: [
            {
              name: 'notificação 3',
              placeholder: 'Dias após da data de vencimento',
              value: null,
            },
            {
              name: 'notificação 4',
              placeholder: 'Dias após da data de vencimento',
              value: null,
            },
          ],
        },
      ],
      channelElement: '',
      statusSelected: '',
      situationSelected: '',
      useTemplateOption: '0',
      selectedTemplateOption: null,
      selectedList: '',
      date: '',
      time: '',
      shippingSchedule: '',
      weekendShippingLock: false,
      notifications: [],
    };
  },
  watch: {
    selectedMessageToEdit: {
      deep: true,
      immediate: true,
      handler(newValue) {
        this.shippingSchedule = this.selectedMessageToEdit.shipping_schedule;
        this.weekendShippingLock = this.selectedMessageToEdit.weekend_shipping_lock;

        if (newValue && newValue.notifications) {
          this.notifications = newValue.notifications;
        } else {
          this.notifications =
            newValue.situation === 'Lembrete'
              ? [
                  {
                    name: 'notificação',
                    position: 1,
                    key: `notification_1`,
                    placeholder: 'Dias antes da data de vencimento',
                    value: null,
                  },
                ]
              : [
                  {
                    name: 'notificação',
                    position: 101,
                    key: `notification_101`,
                    placeholder: 'Dias após da data de vencimento',
                    value: null,
                  },
                ];
        }
        this.updateShippingSchedule();
        this.updateWeekendShippingLock();
        this.updateNotification();
      },
    },
  },
  methods: {
    // VALUES
    updateTitle() {
      this.$emit('updateFormData', { title: this.titleMsgElement });
    },
    updateChannel() {
      this.$emit('updateFormData', { channel: this.channelElement });
    },
    updateCategory() {
      this.$emit('updateFormData', { category: this.category.name });
    },
    updateStatus() {
      this.$emit('updateFormData', { status: this.statusSelected });
    },
    updateSituation() {
      this.$emit('updateFormData', { situation: this.situationSelected.name });
    },
    updateNotification() {
      this.$emit('updateFormData', {
        notifications: this.notifications,
      });
    },
    updateShippingSchedule() {
      this.$emit('updateFormData', {
        shipping_schedule: this.shippingSchedule,
      });
    },
    updateWeekendShippingLock(event) {
      if (typeof event !== 'undefined') {
        this.weekendShippingLock = !this.weekendShippingLock;
      }
      this.$emit('updateFormData', {
        weekend_shipping_lock: this.weekendShippingLock,
      });
    },
    addDinamicNotification(selectedNotification) {
      if (selectedNotification.situation === 'Lembrete') {
        this.notifications.push({
          name: 'notificação',
          key: `notification_${(selectedNotification.notifications &&
            selectedNotification.notifications.length + 1) ??
            this.notifications.length + 1}`,
          position:
            (selectedNotification.notifications &&
              selectedNotification.notifications.length + 1) ??
            this.notifications.length + 1,
          placeholder: 'Dias antes da data de vencimento',
          value: null,
        });
        this.$emit('updateFormData', {
          notifications: this.notifications,
        });
      }
      if (selectedNotification.situation === 'Cobrança') {
        this.notifications.push({
          name: 'notificação',
          key: `notification_${selectedNotification.notifications.length +
            1 +
            100}`,
          position: selectedNotification.notifications.length + 1 + 100,
          placeholder: 'Dias após da data de vencimento',
          value: null,
        });
        this.$emit('updateFormData', {
          notifications: this.notifications,
        });
      }
    },
    removeDinamicNotification(selectedNotification) {
      this.notifications.pop();
    },
  },
};
</script>

<style scoped>
/* .card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  padding: 20px;
  margin: 20px auto;
}
.card-header {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}
.form-group {
  margin-bottom: 15px;
}
.form-control {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 5px;
}
.form-input-control {
  width: 100%;
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.form-input-control input {
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 8px;
} */

.card-wise-wise {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  padding: 20px;
  margin: 20px auto;
}
.card-header-wise {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
}
.card-header-wise span {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 10px;
}
.form-group {
  margin-bottom: 15px;
}
.form-control {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 5px;
}
.form-control-time {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 5px;
}
.shipping-time {
  display: flex;
  gap: 20px;
  width: 100%;
}
.form-input-control {
  width: 100%;
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.form-input-control input {
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 8px;
}
.btn {
  border-radius: 2px;
  text-transform: capitalize;
  font-size: 15px;
  padding: 0.625rem 1.1875rem;
  cursor: pointer;
  border: transparent;
}
.btn-info {
  background-color: #00bcd4;
  border-color: #00bcd4;
  color: #fff;
  cursor: pointer;
  -webkit-transition: all ease-in 0.3s;
  transition: all ease-in 0.3s;
}
.btn-info:hover {
  background-color: #08e3ff;
  border-color: #08e3ff;
}
.btn-info:active {
  background-color: #008697;
  border-color: #008697;
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #fff;
}
.btn-info:focus {
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #fff;
  background-color: #08e3ff;
}
.btn-info.disabled {
  background-color: rgba(0, 188, 212, 0.5);
  border-color: rgba(0, 188, 212, 0.5);
}

.btn-danger {
  background-color: #ff5370;
  border-color: #ff5370;
  color: #fff;
  cursor: pointer;
  -webkit-transition: all ease-in 0.3s;
  transition: all ease-in 0.3s;
}

.btn-danger:hover {
  background-color: #ff869a;
  border-color: #ff869a;
}

.btn-danger:active {
  background-color: #ff163d;
  border-color: #ff163d;
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #fff;
}

.btn-danger:focus {
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #fff;
  background-color: #ff869a;
}

.btn-danger.disabled {
  background-color: rgba(255, 83, 112, 0.5);
  border-color: rgba(255, 83, 112, 0.5);
}
</style>
